import { isNil } from "../lodash";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapReplacer(key: string, value: any) {
  if (value instanceof Map) {
    return {
      __type: "Map",
      value: Array.from(value.entries()),
    };
  }
  return value;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapReviver(key: string, value: any) {
  if (value && typeof value === "object" && "__type" in value && value.__type === "Map" && "value" in value) {
    return new Map(value.value as [unknown, unknown][]);
  }
  return value;
}

export function trySerializeJson(value: unknown, fallback: string = "") {
  try {
    return JSON.stringify(value, mapReplacer);
  } catch {
    return fallback;
  }
}

export function tryParseJson<T = unknown>(value: string, fallback: T): T {
  try {
    return JSON.parse(value, mapReviver) as T;
  } catch {
    return fallback;
  }
}

/**
 * remove entries where the value is null or undefined
 */
export function sanitizeMap<K, V>(value: Map<K, V>) {
  return new Map<K, V>([...value.entries()].filter(([, value]) => !isNil(value)));
}
